export const DATALINK_HISTORY = [
  {
    label: "charts.tableData.created",
    key: "created",
    width: "20%",
    filter: {
      filterName: "dateFormat",
      params: "Y/MM/dd HH:mm", // todo: at the moment we can set only one param
    },
  },
  {
    label: "charts.tableData.originalFiles",
    key: "FileCount",
    custom: true,
  },
  {
    label: "charts.tableData.uploaded",
    key: "file_uploaded",
  },
  {
    label: "charts.tableData.status",
    key: "Status",
    custom: true,
  },
  {
    label: "charts.tableData.sentDate",
    key: "sent",
    filter: {
      filterName: "dateFormat",
      params: "Y/MM/dd HH:mm", // todo: at the moment we can set only one param
    },
  },
  {
    key: "Control",
    width: "20%",
    custom: true,
  },
];

export const DATALINK_DETAILS = [
  { key: "type", label: "charts.tableData.category" },
  { key: "name", label: "charts.tableData.itemName" },
  { key: "product_id", label: "charts.tableData.productId" },
  { key: "size", label: "charts.tableData.size" },
  { key: "data.height", label: "charts.tableData.height" },
  { key: "data.bust", label: "charts.tableData.bust" },
  { key: "data.sleeve", label: "charts.tableData.sleeve" },
  { key: "data.shoulder", label: "charts.tableData.shoulder" },
  { key: "data.waist", label: "charts.tableData.waist" },
  { key: "data.thigh", label: "charts.tableData.thigh" },
  { key: "data.hip", label: "charts.tableData.hip" },
  { key: "data.hem", label: "charts.tableData.hem" },
  { key: "data.inseam", label: "charts.tableData.inseam" },
  { key: "data.frontRise", label: "charts.tableData.frontRise" },
  { key: "data.armOpening", label: "charts.tableData.armOpening" },
  { key: "data.sleeveOpening", label: "charts.tableData.sleeveOpening" },
  { key: "data.knee", label: "charts.tableData.knee" },
  { key: "data.legOpening", label: "charts.tableData.legOpening" },
  { key: "data.backRise", label: "charts.tableData.backRise" },
  { key: "data.waistHeight", label: "charts.tableData.waistHeight" },
  { key: "data.collar", label: "charts.tableData.collar" },
  { key: "data.bicep", label: "charts.tableData.bicep" },
  { key: "data.depth", label: "charts.tableData.depth" },
  { key: "data.width", label: "charts.tableData.height" },
  { key: "data.topWidth", label: "charts.tableData.width" },
  { key: "data.handleDrop", label: "charts.tableData.andleDrop" },
  { key: "data.handleWidth", label: "charts.tableData.handleWidth" },
  { key: "data.lensWidth", label: "charts.tableData.lensWidth" },
  { key: "data.temple", label: "charts.tableData.temple" },
  { key: "data.frameWidth", label: "charts.tableData.frameWidth" },
  { key: "data.bridge", label: "charts.tableData.bridge" },
  { key: "data.frameWidth", label: "charts.tableData.frameWidth" },
];

export const ITEM_COVERAGE_DETAILS = [
  {
    key: "statusKey",
    label: "charts.tableData.status",
    custom: true,
  },
  {
    key: "product_type_id",
    label: "charts.tableData.category",
    custom: true,
  },
  { key: "name", label: "charts.tableData.itemName" },
  { key: "external_id", label: "charts.tableData.productId" },
  { key: "sizeName", label: "charts.tableData.size" },
  { key: "sizes.height", label: "charts.tableData.height" },
  { key: "sizes.bust", label: "charts.tableData.bust" },
  { key: "sizes.sleeve", label: "charts.tableData.sleeve" },
  { key: "sizes.shoulder", label: "charts.tableData.shoulder" },
  { key: "sizes.waist", label: "charts.tableData.waist" },
  { key: "sizes.thigh", label: "charts.tableData.thigh" },
  { key: "sizes.hip", label: "charts.tableData.hip" },
  { key: "sizes.hem", label: "charts.tableData.hem" },
  { key: "sizes.inseam", label: "charts.tableData.inseam" },
  { key: "sizes.frontRise", label: "charts.tableData.frontRise" },
  { key: "sizes.armOpening", label: "charts.tableData.armOpening" },
  { key: "sizes.sleeveOpening", label: "charts.tableData.sleeveOpening" },
  { key: "sizes.knee", label: "charts.tableData.knee" },
  { key: "sizes.legOpening", label: "charts.tableData.legOpening" },
  { key: "sizes.backRise", label: "charts.tableData.backRise" },
  { key: "sizes.waistHeight", label: "charts.tableData.waistHeight" },
  { key: "sizes.collar", label: "charts.tableData.collar" },
  { key: "sizes.bicep", label: "charts.tableData.bicep" },
  { key: "sizes.depth", label: "charts.tableData.depth" },
  { key: "sizes.width", label: "charts.tableData.height" },
  { key: "sizes.topWidth", label: "charts.tableData.width" },
  { key: "sizes.handleDrop", label: "charts.tableData.handleDrop" },
  { key: "sizes.handleWidth", label: "charts.tableData.handleWidth" },
  { key: "sizes.lensWidth", label: "charts.tableData.lensWidth" },
  { key: "sizes.temple", label: "charts.tableData.temple" },
  { key: "sizes.frameWidth", label: "charts.tableData.frameWidth" },
  { key: "sizes.bridge", label: "charts.tableData.bridge" },
  { key: "sizes.frameWidth", label: "charts.tableData.frameWidth" },
];
